var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBebe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 22q-.425 0-.712-.288T3 21v-8.675q0-.175.025-.337t.075-.313l1.475-4.3q.2-.65.75-1.012T6.5 6q.2 0 .4.038t.4.137L11.45 8H13q.425 0 .713.288T14 9t-.288.713T13 10h-1.575q-.2 0-.4-.05t-.4-.125l-2.325-1L7 12.75V21q0 .425-.287.713T6 22zm6-3q-.425 0-.712-.288T9 18t.288-.712T10 17h10q.425 0 .713.288T21 18t-.288.713T20 19zm9.5-3q-.625 0-1.062-.437T18 14.5t.438-1.062T19.5 13t1.063.438T21 14.5t-.437 1.063T19.5 16M13 16q-.825 0-1.412-.587T11 14v-1h-1q-.425 0-.712-.288T9 12t.288-.712T10 11h2q.425 0 .713.288T13 12v1h2v-1q0-.425.288-.712T16 11t.713.288T17 12v2q0 .825-.587 1.413T15 16zM8 5q-.825 0-1.412-.587T6 3t.588-1.412T8 1t1.413.588T10 3t-.587 1.413T8 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBebe);
export default __webpack_public_path__ + "static/media/ic_bebe.d77e3300838308affb1a2ba893c21d6f.svg";
export { ForwardRef as ReactComponent };